import React from "react";
import styled from "styled-components";
import LogoutIcon from "react-icons/lib/io/log-out";
import get from "lodash/get";
import Stack from "@unibuddy/machop/Experimental/Layout/components/Stack/Stack";
import Tooltip from "@unibuddy/machop/Experimental/General/components/Tooltip/Tooltip";
import TextBlock from "@unibuddy/machop/Experimental/Typography/components/TextBlock/TextBlock";
import Inline from "@unibuddy/machop/Experimental/Layout/components/Inline/Inline";
import useRelativeRouter from "@unibuddy/machop/Navigation/hooks/useRelativeRouter/useRelativeRouter";
import ButtonLink from "@unibuddy/machop/Experimental/General/components/ButtonLink/ButtonLink";
import useAuth from "@unibuddy/machop/Auth/hooks/useAuth";
import LiveEventAvatar from "../../../Chat/components/LiveEventAvatar/LiveEventAvatar";

const Container = styled.div`
    padding-right: 4rem;
    position: relative;
`;

const LogoutButton = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
`;

const accountRoles = {
    university: "University",
    applicant: "Student",
    mentor: "Student Ambassador",
    staff: "Staff",
    admin: "Unibuddy Admin",
};

export default function UserProfileLine() {
    const {path} = useRelativeRouter();
    const {authState} = useAuth();
    const user = get(authState, "me.anyUser");

    if (!user) return null;

    return (
        <Container>
            <Inline verticalAlign="center" space="small" wrap="nowrap">
                <LiveEventAvatar sender={user} />
                <Stack space="xsmall">
                    <TextBlock size="large">
                        {user.firstName} {user.lastName}
                    </TextBlock>
                    <TextBlock tone="secondary">{accountRoles[user.accountRole]}</TextBlock>
                </Stack>
            </Inline>
            <LogoutButton>
                <Tooltip label="Logout">
                    <ButtonLink
                        aria-label="Logout"
                        data-test-id="logout"
                        size="sm"
                        round
                        iconOnly
                        clear
                        to={`${path}/auth/logout`}
                    >
                        <LogoutIcon aria-hidden />
                    </ButtonLink>
                </Tooltip>
            </LogoutButton>
        </Container>
    );
}
